// src/App.js

import React from "react";
import {
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import Home from "./components/Pages/Home";
import Login from "./components/Pages/Login";

// Client Modules
import ManageClients from "./components/Clients/ManageClients";
import AddClients from "./components/Clients/AddClients";
import EditClients from "./components/Clients/EditClients";

// License Modules
import ManageLicense from "./components/License/ManageLicense";
import UpdateLicense from "./components/License/UpdateLicense";

// Server Modules
import ManageServer from "./components/Server/ManageServer";
import EditServer from "./components/Server/EditServer";

import "./App.css";

function PrivateRoute({ children }) {
  const isLoggedIn = localStorage.getItem("isLoggedIn");

  return isLoggedIn ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <div className="dashboard-container flex">
      <div className="main-content flex-1">

        <Routes>

          <Route
            path="/login"
            element={<Login />}
          />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />

          <Route
            path="/manage-clients"
            element={
              <PrivateRoute>
                <ManageClients />
              </PrivateRoute>
            }
          />

          {/* alias: কিছু কম্পোনেন্ট /clients এ navigate করে */}
          <Route path="/clients" element={<Navigate to="/manage-clients" replace />} />

          <Route
            path="/clients/add"
            element={
              <PrivateRoute>
                <AddClients />
              </PrivateRoute>
            }
          />

          <Route
            path="/clients/edit/:id"
            element={
              <PrivateRoute>
                <EditClients />
              </PrivateRoute>
            }
          />

          <Route
            path="/manage-license"
            element={
              <PrivateRoute>
                <ManageLicense />
              </PrivateRoute>
            }
          />

          <Route
            path="/update-license"
            element={
              <PrivateRoute>
                <UpdateLicense />
              </PrivateRoute>
            }
          />

          <Route
            path="/manage-server"
            element={
              <PrivateRoute>
                <ManageServer />
              </PrivateRoute>
            }
          />

          {/* alias: কিছু কম্পোনেন্ট /servers এ navigate করে */}
          <Route path="/servers" element={<Navigate to="/manage-server" replace />} />

          <Route
            path="/servers/edit/:id"
            element={
              <PrivateRoute>
                <EditServer />
              </PrivateRoute>
            }
          />

          <Route
            path="*"
            element={<Navigate to="/login" />}
          />

        </Routes>

      </div>
    </div>
  );
}

export default App;